export const RF_ROLLOUT_GATE = 'react-first-rollout' as const;
export const RF_ROLLOUT_STORAGE_KEY = 'rf-rollout-redirect-base-url' as const;
